//for converting base64 image to file
export function base64ToFile(base64Image: string): Blob {
  const split = base64Image.split(',');
  const type = split[0].replace('data:', '').replace(';base64', '');
  const byteString = atob(split[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type });
}

// for converting blob to file
export function convertBlobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      if (reader.result) {
        resolve(reader.result as string);
      } else {
        reject(new Error('Failed to convert blob to base64'));
      }
    };
    reader.onerror = (error) => {
      const errorMessage =
        error instanceof Error ? error.message : JSON.stringify(error);
      reject(new Error(`FileReader error: ${errorMessage}`));
    };
  });
}
// Method to check if the image URL is in base64 format or not
export function isImageFormatBase64(image: string) {
  const base64Pattern =
    /^data:(image\/(jpeg|png|gif|bmp|webp)|application\/octet-stream);base64,[A-Za-z0-9+/]+={0,2}$/;
  return image && base64Pattern.test(image);
}
